<dialog-header>Delete Permanently?</dialog-header>
<form id="confirmForm" autocomplete="off" (ngSubmit)="delete()">
  <div class="modal-body mb-2">
    <p class="align-left">
      <span>
        <strong>{{ companyItems + subCompanyItems }}</strong>
        {{ companyItems + subCompanyItems > 1 ? 'items' : 'item' }} will be
        deleted.
      </span>
      <ng-container [ngSwitch]="itemName">
        <span *ngSwitchCase="'Display'"
          >Deleted displays will be removed, and all folder contents will be
          lost.</span
        >
        <span *ngSwitchCase="'Presentation'"
          >Deleted presentations will also be removed from schedules, and all
          folder contents will be lost.</span
        >
        <span *ngSwitchCase="'Schedule'"
          >Deleted schedules will also be removed from assigned displays, and
          all folder contents will be lost.</span
        >
      </ng-container>
    </p>
    <div class="align-left u_margin-md-top">
      <p class="mb-2 tw-font-medium">
        Type "{{ expectedText }}" to confirm deletion:
      </p>
      <input
        name="confirmInput"
        class="w-100 form-control"
        type="text"
        [(ngModel)]="inputText"
        [focusMe]="true"
      />
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button rv-button variant="secondary" type="button" (click)="dismiss()">
      Cancel
    </button>
    <button
      type="submit"
      id="confirm-primary"
      mat-flat-button
      color="warn"
      [disabled]="inputText !== expectedText"
    >
      Delete Permanently
    </button>
  </mat-dialog-actions>
</form>
